/** @file startClock: a clip clock at time 0, fading the previous clip out when a blend time is given. */
import type { Clip } from '@zilo/pose3d-format/types/clip';
import type { ClipClock } from '@zilo/pose3d-runtime-babylon/clip/clipClockTypes';

/** Time 0, `prevTime` null; `blendFrom` = the previous clock's clip and time when `previous` and `blendSeconds > 0`. */
export function startClock(clip: Clip, previous: ClipClock | null, blendSeconds: number): ClipClock {
  const blendFrom = previous !== null && blendSeconds > 0
    ? { clip: previous.clip, time: previous.time, elapsed: 0, duration: blendSeconds }
    : null;
  return { clip, time: 0, prevTime: null, paused: previous?.paused ?? false, blendFrom };
}
